'use strict';

customerZone

/**
 * A datepicker component wrapping the standard 720kb datepicker.  This one has a bit of a cleaner interface.
 * Also, on clients with a decent enough native datepicker, that one will be used instead.
 *
 * All dates handled by this picker are Moments (see momentjs.com).
 *
 * @param Moment ng-model: model value to bind to
 * @param expression ng-change: executed when the selected moment has changed
 * @param Moment date-max-limit: maximum value accepted (optional)
 * @param string input-id: id for the input element (use this to link a label)
 */
.component('jimDatePicker', {
    bindings: {
        dateMaxLimit: '<',
        ngModel: '=',
        ngChange: '&',
        inputId: '@',
        required: '<'
    },
    templateUrl: customerZone.fromBase('components/datepicker/datepicker.component.html'),
    controller: ['$timeout', '$log', function($timeout, $log){
        var vm = this;
        var BELGIAN_DATE_FORMAT = 'DD/MM/YYYY';

        var lastChange;

        vm.onChange = function(){
            if (lastChange)
                $timeout.cancel(lastChange);
            lastChange = $timeout(function(){
                if (vm.ngChange) vm.ngChange();
            }, 100);
        };

        /**
         * A property representing the current value expressed in belgian date format
         */
        Object.defineProperty(this, 'belValue', {
            set: function(value){
                var toSet = undefined;
                if (value)
                    toSet = moment(value + ' +0000', BELGIAN_DATE_FORMAT + ' Z');
                if (!toSet || toSet.isValid())
                    this.ngModel = toSet;
            },
            get: function(){
                if (!this.ngModel) return '';
                if (!this.ngModel.format) {
                    $log.error('ngModel for datepicker is pointing at something that is not a moment', this.ngModel);
                    return '';
                }
                return this.ngModel.format(BELGIAN_DATE_FORMAT);
            }
        });

        /**
         * A property representing the current value as a js Date.
         */
        Object.defineProperty(this, 'date', {
            set: function(value){
                if (!value) this.ngModel = undefined;
                else this.ngModel = moment(value);
            },
            get: function(){
                if (!this.ngModel) return '';
                return asDate(this.ngModel);
            }
        });

        /**
         * A little wrapper around moment.toDate to make sure we always return the same object reference. This
         * prevents angular from going into an infDig.
         *
         * Note: this essentially leaks memory.  We don't expect the user to select hundreds of dates, so it's
         * probably okay.
         */
        var asDate = function(momentValue){
            var repr = momentValue.toISOString();
            if (!knownDates[repr]) {
                knownDates[repr] = momentValue.toDate();
            }
            return knownDates[repr];
        };

        var knownDates = {};

        this.useNativePicker = false;
        /*
         * Motivation:  The user agent string is generally not a good way to detect features; but in this instance,
         * we're trying to determine if the client has a native picker that will give a better user experience
         * than the 720kb one, which can only be done manually.
         *
         * For example, chrome (desktop) and edge have native pickers, but they are not very user friendly.  The
         * only way to solve that is to keep a list of agents of which we know have a good enough picker. And the
         * only way of achieving that is using the user agent string.
         *
         * Even if we make mistakes here, the fallback to 720kb is acceptable as well.
         *
         * The only cases we know at the moment of good pickers are IOS Safari and Chrome for IOS/Android, all of
         * which will use the OS built-in picker.
         *
         * Add any here when you find new examples.
         *
         * Some point in the future, all browsers will have nice pickers and we can ditch this.
         */
        try {
            var uaString = navigator.userAgent;
            if (/Android/.exec(uaString) && /Chrome\/[.0-9]* Mobile/.exec(uaString))
                this.useNativePicker = true;
            if (/CriOS\/[.0-9]* Mobile/.exec(uaString))
                this.useNativePicker = true;
            if (/Mobile\/[.0-9a-zA-Z]* Safari/.exec(uaString))
                this.useNativePicker = true;
        }
        catch (_) { /* noop */ }
    }]
});
